import React from 'react'
import { NavLink } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { formatDate } from 'lib/lib'
import { ArrowCircleRight } from "phosphor-react"
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton'

class EventsCard extends React.Component {
    constructor(props) {
        super(props)
        this.handleClick = this.handleClick.bind(this)
        this.link = `/event/${this.props.id}`
        this.state = {
            imageLoaded: false,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
    }

    handleClick(event) {
        event.preventDefault()
        this.props.props.history.push(`/event/${this.props.id}`)
    }

    render() {
        const { t } = this.props
        return (
            <div className="col-12 events-card">
                {
                    this.props.skeleton ?
                        <div className="events-wrapper card">
                            <div className="events-img card-img">
                                <Skeleton height={300} />
                            </div>
                            <div className="events-content card-body">
                                <div className="news-date xs-font-size"><Skeleton width={'20%'} /></div>
                                <span className="news-title md-font-size"><Skeleton count={2} /></span>
                                <div className="news-desc md-font-size"><Skeleton count={4} /></div>
                                <div className="news-white-space"></div>
                                <div className="btn news-btn"><Skeleton className="float-left" width={'30%'} /></div>
                            </div>
                        </div>
                        :
                        <div className="events-wrapper card">
                            {!this.state.imageLoaded && this.props.image && <div className="events-img card-img"><Skeleton height={300} /></div>}
                            {this.props.image && <img onLoad={() => this.setState({ imageLoaded: true })} src={`${this.state.imageUrl}/${this.props.image}`} alt="" className={`events-img card-img${this.state.imageLoaded ? '' : ' d-none'}`} onClick={this.handleClick} />}

                            <div className="events-content card-body">
                                <div className="news-date xs-font-size">{formatDate(this.props.date)}</div>
                                <NavLink className="news-title md-font-size" to={this.link}>{this.props.title}</NavLink>
                                <div className="news-desc md-font-size" dangerouslySetInnerHTML={{ __html: this.props.desc }}></div>
                                <div className="news-white-space"></div>
                                <button type="button" className="btn news-btn" onClick={this.handleClick}>
                                    <div className="news-btn-content">
                                        <ArrowCircleRight size={20} className="icon-primary" />
                                        <span className="news-btn-desc sm-font-size">{t('news-read-more')}</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                }
            </div >
        )
    }
}

EventsCard.propTypes = {
    id: PropTypes.number,
    props: PropTypes.object,
    date: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.string,
    desc: PropTypes.string,
    t: PropTypes.func,
    skeleton: PropTypes.bool,
}

export default withTranslation()(EventsCard)



// WEBPACK FOOTER //
// ./src/components/Events/EventsCard.jsx